var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"oval"}),_c('h3',{staticClass:"font-semibold leading-tight"},[_vm._v(_vm._s(_vm.title))]),_c('h4',{staticClass:"text-base font-semibold mb-6 leading-tight"},[_vm._v(_vm._s(_vm.subtitle))])]),_c('p',{staticClass:"mb-6"},[_vm._v(_vm._s(_vm.body))])])
}
var staticRenderFns = []

export { render, staticRenderFns }